import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useEffect, useMemo, useContext } from 'react';
import { exposeGlobally } from '../utils/utils.js';

const PayPalButtonContext = createContext({
    onApprove: async () => { },
    onCancel: () => { },
    isButtonDisabled: false,
});
const usePayPalButtonContext = () => useContext(PayPalButtonContext);
const PayPalButtonContextProvider = ({ onApprove, onCancel, userIdToken, children, }) => {
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const disablePayPalButton = () => {
        setIsButtonDisabled(true);
    };
    const enablePayPalButton = () => {
        setIsButtonDisabled(false);
    };
    useEffect(() => {
        // Expose the two functions globally, so that "shop-checkout" will be
        // able to toggle the PayPal buttons from their side.
        exposeGlobally('disablePayPalButton', disablePayPalButton);
        exposeGlobally('enablePayPalButton', enablePayPalButton);
    }, []);
    // Memo the provider value object to prevent unwanted render of the Provider
    const providerValue = useMemo(() => {
        return {
            onApprove,
            onCancel,
            isButtonDisabled,
            userIdToken,
        };
    }, [onApprove, onCancel, isButtonDisabled, userIdToken]);
    return (jsx(PayPalButtonContext.Provider, { value: providerValue, children: children }));
};

export { PayPalButtonContextProvider as default, usePayPalButtonContext };
//# sourceMappingURL=PayPalButtonContextProvider.js.map
